// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2737) return "static/chunks/mui-473a13bd7017be71.js";
	if (chunkId === 1229) return "static/chunks/1229-1f492e1109f06ad2.js";
	if (chunkId === 9501) return "static/chunks/9501-7e91fbb517e93658.js";
	if (chunkId === 2014) return "static/chunks/2014-56cae1afd794617a.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"7538":"recorder","9983":"profiler"}[chunkId] || chunkId) + "." + {"526":"57f2bfc2450c2fa5","4878":"2254d9995bc9a3af","7538":"1322f0e63ceff47c","9421":"3759f115149ca56b","9983":"f7ac861f12387ae8"}[chunkId] + ".js";
};